import React, { useRef } from "react";
import { useState, useEffect } from "react";
import { useGlobalState } from "../Context/GlobalStateContext";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import AppContext from "../Context/Context";
import DragDrop from "../DragDrop/DragDrop";
import { SortTheList } from "../Shared/Utility";
import LockUnlock from "../App/LockUnlock";
import ConfirmationModal from "../App/ConfirmationModal";
import ColumnFilterCheckboxList from "../App/ColumnFilterCheckboxList";
import LockUnlockV2 from "../App/LockUnlockV2";
type Props = {
  Type: number;
  PID: any;
};
function ProductFaqs(props: Props) {
  const globalState = useGlobalState();
  const [showAnimation, setShowAnimation] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [locked, setLocked] = useState(true);
  const [selectedStatus, setSelectedStatus] = useState(0);
  const [type, setType] = useState(props.Type);
  const [parentID, setParentID] = useState(props.PID);

  const [showOrders, setShowOrders] = useState(false);
  useEffect(() => {}, []);

  useEffect(() => {
    getObjectAdminData(0, 0);
  }, [parentID]);

  function getObjectAdminData(add: any, pid: any) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.type = type;
    object.add = add;
    object.pid = parentID;
    object.status = 1;
    setShowAnimation(true);
    axiosAuth
      .post(AppContext.APIURL + "api/PTProduct/GetObjectAdminData", object)
      .then((response) => {
        if (response.data.Status === 1) {
          var l_response = response.data.Data;
          const deepCopy1 = JSON.parse(JSON.stringify(l_response));
          const deepCopy2 = JSON.parse(JSON.stringify(l_response));
          setThisGridListDataWithoutFilters(deepCopy1);
          setThisGridListData(deepCopy2[0]);
          thisGridListDataRef.current = deepCopy2[0];
        } else {
          console.log("error", response.data.Message);
        }
        setShowAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function updateValue(value: string, index: any, colName: string) {
    let thisAdminData: any = [...thisGridListData];
    thisAdminData[index][colName] = value;
    setThisGridListData(thisAdminData);
  }
  function updateObjectAdminData(
    pid: any,
    colvalue: string,
    colname: any,
    filesdata: any,
    fileobjecttype = 0,
  ) {
    let object = {} as any;
    object.appid = AppContext.App;
    object.type = type;
    object.pid = pid;
    object.colname = colname;
    object.colvalue = colvalue;
    object.filesdata = filesdata;
    object.fileobjecttype = fileobjecttype;
    axiosAuth
      .post(AppContext.APIURL + "api/PTProduct/UpdateObjectAdminData", object)
      .then((response) => {
        if (response.data.Status === 1) {
          var l_response = response.data.Data;
          if (
            colname == "del" ||
            colname == "archive" ||
            colname == "undoarchive" ||
            colname == "Filesdata" ||
            colname == "delimg" ||
            colname == "PTOrderBy"
          ) {
            getObjectAdminData(0, 0);
          }
        } else {
          console.log("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function ConfirmationModalCallBack(obj: any) {
    if (obj.ID === 1) {
      if (obj.isConfirm === true) {
        updateObjectAdminData(obj.SelectedID, "", "del", []);
      }
    }

    if (obj.ID === 100) {
      if (obj.isConfirm === true) {
        updateObjectAdminData(obj.SelectedID, "", "archive", []);
      }
    }

    if (obj.ID === 101) {
      if (obj.isConfirm === true) {
        updateObjectAdminData(obj.SelectedID, "", "undoarchive", []);
      }
    }

    globalState.setConfirmationModalObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID: 0,
      OtherID: 0,
    });
  }

  ///--States for columnFilter components---///
  const [clearFilters, setClearFilters] = useState(false);
  const [refreshFilters, setRefreshFilters] = useState(false);
  const [getFilteredLists, setGetFilteredLists] = useState(false);
  const [selectedColumnName, setSelectedColumnName] = useState("");
  const [thisGridListDataWithoutFilters, setThisGridListDataWithoutFilters] =
    useState<any>([]);
  const [thisGridListData, setThisGridListData] = useState<any>([]);
  const thisGridListDataRef = useRef<any | null>(null);
  thisGridListDataRef.current = thisGridListData;
  const [clickPosition, setClickPosition] = useState<any>({ x: null, y: null });
  function ShowColumnFilterList(event: any, Name: string) {
    if (Name === selectedColumnName) {
      setSelectedColumnName("");
    } else {
      setClickPosition({ x: event.clientX, y: event.clientY });
      setSelectedColumnName(Name);
    }
  }

  function filterCheckboxListCallback(FilterData: any) {
    setSelectedColumnName("");
    let l_data = []; //[...COPAInvoicesGridData] as any;
    l_data = [...FilterData];
    //setCOPAInvoicesGridData([...l_data]);

    setThisGridListData([...FilterData]);
    thisGridListDataRef.current = [...FilterData];
  }

  function ClearAllFilters() {
    const deepCopy = JSON.parse(JSON.stringify(thisGridListDataWithoutFilters));
    setThisGridListData(deepCopy[0]);
    thisGridListDataRef.current = deepCopy[0];
    setClearFilters(!clearFilters);
  }

  //--States for columnFilter components---///

  ////  Sorting Starts    /////
  const [filtersSort, setFiltersSort] = useState(["", "D"]);
  useEffect(() => {
    SetSortingImage();
  }, [thisGridListData]);

  function SetSortingImage() {
    if (thisGridListData && thisGridListData.length > 0) {
      if (document.getElementById("imgSortName")) {
        (document.getElementById("imgSortName") as HTMLInputElement).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
      if (document.getElementById("imgSortDescription")) {
        (
          document.getElementById("imgSortDescription") as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
      if (document.getElementById("imgSortEmailTo")) {
        (
          document.getElementById("imgSortEmailTo") as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
      if (document.getElementById("imgSortTicketNumberPrefix")) {
        (
          document.getElementById(
            "imgSortTicketNumberPrefix",
          ) as HTMLInputElement
        ).innerHTML =
          '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
      }
    }

    var l_strClassimgAdd =
      '<img src="images/asc.svg" width="10px" height="13px" alt="B"/>';
    if (filtersSort[1] == "D") {
      l_strClassimgAdd =
        '<img src="images/desc.svg" width="10px" height="13px" alt="B"/>';
    }
    if (
      filtersSort[0] != "" &&
      document.getElementById("imgSort" + filtersSort[0])
    )
      (
        document.getElementById("imgSort" + filtersSort[0]) as HTMLInputElement
      ).innerHTML = l_strClassimgAdd;
  }

  function LoadWithSelectedSort(p_strColumnName: any) {
    var l_strSortExpression = filtersSort[0];
    var l_strSortDirection = filtersSort[1];
    if (l_strSortExpression == p_strColumnName) {
      if (l_strSortDirection == "D") {
        filtersSort[1] = "A";
      } else {
        filtersSort[1] = "D";
      }
    } else {
      filtersSort[1] = "D";
    }
    if (document.getElementById("imgSort" + filtersSort[0])) {
      (
        document.getElementById("imgSort" + filtersSort[0]) as HTMLInputElement
      ).innerHTML =
        '<img src="images/none.svg" width="10px" height="13px" alt="B"/>';
    }
    filtersSort[0] = p_strColumnName;
    HandleSortAndLoadData();

    SetSortingImage();
  }

  function HandleDataLoad(GridData: any) {
    let data: any = [...GridData];
    setThisGridListData(data);
    SetSortingImage();
  }

  function HandleSortAndLoadData() {
    if (filtersSort[0] != "") {
      var SortedGridData = SortTheList(
        thisGridListDataRef.current,
        filtersSort[0],
        filtersSort[1],
      );
      HandleDataLoad(SortedGridData);
    } else {
      HandleDataLoad(thisGridListDataRef.current);
    }
  }
  ////  Sorting Ends    ////

  return (
    <>
      <ConfirmationModal
        ConfirmationObject={globalState.ConfirmationModalObject}
        ConfirmationModalCallBack={ConfirmationModalCallBack}
      />
      {thisGridListData && thisGridListData.length > 0 && (
        <ColumnFilterCheckboxList
          DataType={1}
          RefreshFilters={refreshFilters}
          ClearFilters={clearFilters}
          GridData={thisGridListData}
          ColumnName={selectedColumnName}
          ColumnFilterCheckboxListCallback={filterCheckboxListCallback}
          GetFilteredLists={getFilteredLists}
          ReturnAllFilterdLists={{}}
          ClickPosition={clickPosition}
          Orientation={"Center"}
          ColumnOrientation={[{ Name: "Name", Orientation: "Right" }]}
        />
      )}

      {showAnimation && <LoadingAnimation />}

      <div className="flex-d justify-btw mb-10 mt-20">
        <span></span>
        {/* <div className="flex-da flex-gap10">
                <select
                  value={selectedStatus}
                  onChange={(e: any) => setSelectedStatus(e.target.value)}
                >
                  <option value="0">All Products</option>
                  {thisGridListDataWithoutFilters[1] &&
                    thisGridListDataWithoutFilters[1].map(
                      (item: any, index: any) => (
                        <React.Fragment key={index}>
                          <React.Fragment key={index}>
                            <option value={item.PID}>{item.Name}</option>
                          </React.Fragment>
                        </React.Fragment>
                      ),
                    )}
                </select>
              </div> */}
        {editMode == false && (
          <div className="flex-da flex-gap10">
            {/* <a
              className="link-btn btn-link-m"
              onClick={() => ClearAllFilters()}
            >
              Clear All Filters
            </a> */}
            {locked == false && (
              <>
                <div className="com-toggle">
                  <span className="txt-compare bold-font">Show Order</span>

                  <a
                    className={showOrders ? "com-btn com-sel" : "com-btn"}
                    onClick={() => {
                      setShowOrders(!showOrders);
                    }}
                  >
                    <span></span>
                  </a>
                </div>
                <div className="flex-daj btn-start">
                  <a
                    onClick={() => getObjectAdminData(1, 0)}
                    className=" flex-daj btn-primary"
                  >
                    Add New
                  </a>
                </div>
              </>
            )}

            <LockUnlockV2 locked={locked} setLocked={setLocked} />
          </div>
        )}
      </div>

      <div className="flow-auto">
        <>
          <table className="reuse-table">
            <thead>
              <tr>
                <th>Question</th>
                <th>Answer</th>
                <th className="td-xxs">Ordering</th>
                <th className="td-xxs">Action</th>
              </tr>
            </thead>
            <tbody>
              {thisGridListData &&
                thisGridListData.map((item: any, index: any) => (
                  <React.Fragment key={index}>
                    {!item.IsExcluded && (
                      <tr>
                        <td className="p-all0">
                          <textarea
                            className="w-100 h-32"
                            disabled={locked}
                            value={item.Question}
                            onChange={(e) =>
                              updateValue(e.target.value, index, "Question")
                            }
                            onBlur={(e) =>
                              updateObjectAdminData(
                                item.PID,
                                e.target.value,
                                "Question",
                                [],
                              )
                            }
                          />
                        </td>
                        <td className="p-all0">
                          <textarea
                            className="w-100 h-32"
                            disabled={locked}
                            value={item.Answer}
                            onChange={(e) =>
                              updateValue(e.target.value, index, "Answer")
                            }
                            onBlur={(e) =>
                              updateObjectAdminData(
                                item.PID,
                                e.target.value,
                                "Answer",
                                [],
                              )
                            }
                          />
                        </td>
                        <td className="text-center reused-tdxs">
                          <div className="flex-daj flex-gap10">
                            <button
                              className="no-borbg pointer"
                              disabled={index == 0 || locked ? true : false}
                              title="Up"
                              onClick={(e) =>
                                updateObjectAdminData(
                                  item.PID,
                                  "up",
                                  "PTOrderBy",
                                  [],
                                )
                              }
                            >
                              <img
                                src="images/o-up.svg"
                                width="14px"
                                height="16px"
                                alt="up"
                              />
                            </button>
                            <button
                              className="no-borbg pointer"
                              disabled={
                                index == thisGridListData.length - 1 || locked
                                  ? true
                                  : false
                              }
                              title="Down"
                              onClick={(e) =>
                                updateObjectAdminData(
                                  item.PID,
                                  "down",
                                  "PTOrderBy",
                                  [],
                                )
                              }
                            >
                              <img
                                src="images/o-down.svg"
                                width="14px"
                                height="16px"
                                alt="down"
                              />
                            </button>

                            {showOrders && (
                              <>
                                <input
                                  className="text-right"
                                  disabled={locked}
                                  value={item.PTOrderBy}
                                  onChange={(e) =>
                                    updateValue(
                                      e.target.value,
                                      index,
                                      "PTOrderBy",
                                    )
                                  }
                                  onBlur={(e) =>
                                    updateObjectAdminData(
                                      item.PID,
                                      e.target.value,
                                      "PTOrderBy",
                                      [],
                                    )
                                  }
                                />
                              </>
                            )}
                          </div>
                        </td>
                        <td className="text-center reused-tdxs">
                          <div className="flex-daj flex-gap10">
                            <a
                              title="Delete"
                              onClick={() =>
                                globalState.setConfirmationModalObject({
                                  ShowPopup: true,
                                  Heading: "Alert",
                                  Message:
                                    "Are your sure, you want to delete this record?",
                                  ID: 1,
                                  SelectedID: item.PID,
                                  OtherID: 0,
                                })
                              }
                            >
                              <img
                                src="images/delete.png"
                                width="17px"
                                height="17px"
                                alt="Edit"
                              />
                            </a>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
            </tbody>
          </table>
        </>
      </div>
    </>
  );
}
export default ProductFaqs;
